"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_REFUND_REQUEST_EXAMPLES = exports.processRefundRequestSchema = void 0;
/**
 * Request contract for the 1 Refund endpoint —
 * `RefundApplicationService.processRefund`
 * (`backend/src/modules/financial/application/refund.application-service.ts`,
 * frozen, Stage 5C.3). Validation (TD-5A-3's refund-ceiling
 * enforcement, one-shot-per-receipt) is entirely `RefundProcessingService`'s
 * — this contract carries no validation logic of its own beyond shape.
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.processRefundRequestSchema = zod_1.z.object({
    originalReceiptId: zod_1.z.string().uuid(),
    refundAmount: zod_1.z.number().int().positive(),
    branchId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().optional(),
    /** Multi-partial-refund follow-up — set by the Pharmacy Returns workflow to gate this refund to at most once per returned line. Omitted for a manual, line-agnostic refund (e.g. Finance's own Refunds & Credit Notes screen). */
    pharmacySaleLineId: zod_1.z.string().uuid().optional(),
    /**
     * ADR-090 Phase 5G — WHICH invoice line this refund reverses.
     *
     * Set when the operator explicitly selects a line on the refund screen.
     * OPTIONAL, and omitting it is a real choice rather than an oversight: a
     * whole-receipt reversal legitimately names no line, and every pre-existing
     * caller continues to work untouched.
     *
     * Inert to the refund arithmetic — it records attribution and changes no
     * amount. Its consumer is the laboratory, which cannot otherwise tell which
     * of an invoice's tests a PARTIAL refund reversed, and which therefore
     * refuses to guess when this is absent.
     *
     * Mirrors `pharmacySaleLineId` above, which exists for the same reason on the
     * Pharmacy Returns path.
     */
    finInvoiceLineId: zod_1.z.string().uuid().optional(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_REFUND_REQUEST_EXAMPLES = {
    processRefund: {
        originalReceiptId: '55555555-5555-5555-5555-555555555555',
        refundAmount: 50000,
        branchId: '33333333-3333-3333-3333-333333333333',
        reason: 'Patient requested partial refund',
    },
};
//# sourceMappingURL=financial-refund.request.js.map